export enum OnboardingStep {
	Profile = 'profile',
	Test = 'test',
	FirstInteraction = 'first_interaction'
}

export interface OnboardingProgress {
	currentStep: OnboardingStep;
	completedSteps: OnboardingStep[];
	completedAt?: number;
	lastUpdatedAt: number;
	interactionSource?: 'favorite' | 'message';
}
